import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Stack,
  IconButton,
  Divider,
  Card,
  CardContent,
  Chip,
} from "@mui/material";
import Icons from "../../../assets/js/Icons";
import {  FILE_PATH_URI } from "../../../utils/helper";
import Images from "../../../assets/js/Images";
const ShareDialog = ({ open, onClose, forumData }) => {
  const location = window.location.origin;
  const shareUrl = `${location}/forum/${forumData?._id}`;
  const handleFacebookShare = () => {
    try {
      const fbUrl = new URL("https://www.facebook.com/sharer/sharer.php");

      fbUrl.searchParams.append("u", shareUrl);
      fbUrl.searchParams.append("quote", forumData?.title || "Check this out!");

      const popup = window.open(
        fbUrl.toString(),
        "facebook-share-dialog",
        "width=626,height=436,resizable=yes,scrollbars=yes,toolbar=no,menubar=no,location=no"
      );

      if (popup) {
        popup.focus();
      } else {
        console.error("Popup blocked or failed to open");
      }
    } catch (error) {
      console.error("Facebook share error:", error);
    }
  };

  // const handleFacebookShare = async () => {
  //   try {
  //     const shareData = {
  //       url: shareUrl,
  //       title: forumData?.title,
  //       description: forumData?.description,
  //       image: forumData?.banner?.path
  //         ? FILE_PATH_URI + forumData?.banner?.path
  //         : Images?.forumImg4,
  //       caption: "Shared via Forum",
  //     };

  //     const result = await shareToFacebook(shareData);

  //     if (result.success) {
  //     } else if (result.cancelled) {
  //     }
  //   } catch (error) {
  //   } finally {
  //   }
  // };

  const handleTwitterShare = () => {
    try {
      const twitterText = forumData?.title || "Check out this forum post!";
      const params = new URLSearchParams({
        url: shareUrl,
        text: twitterText,
        hashtags: "forum,discussion",
      });

      const twitterUrl = `https://x.com/intent/tweet?${params.toString()}`;
      const popup = window.open(
        twitterUrl,
        "twitter-share-dialog",
        "width=626,height=436,resizable=yes,scrollbars=yes,toolbar=no,menubar=no,location=no"
      );

      if (popup) {
        popup.focus();
      } else {
      }
    } catch (error) {
      console.error("X share error:", error);
    }
  };

  if (!forumData) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
        }}
      >
        <Typography fontWeight="600">Share Post</Typography>
        <IconButton onClick={onClose} size="small">
          <Icons.Cross />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 3, py: 2 }}>
        <Card
          sx={{
            mb: 3,
            border: "1px solid",
            borderColor: "divider",
            boxShadow: "none",
          }}
        >
          <CardContent sx={{ p: 2 }}>
            {forumData?.banner?.path && (
              <Box
                component="img"
                src={
                  forumData?.banner?.path
                    ? FILE_PATH_URI + forumData?.banner?.path
                    : Images?.forumImg4
                }
                alt={forumData.title}
                sx={{
                  width: "100%",
                  height: 120,
                  objectFit: "cover",
                  borderRadius: 1,
                  mb: 2,
                }}
              />
            )}
            <Typography
              variant="h6"
              fontWeight="600"
              sx={{
                mb: 1,
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
              }}
            >
              {forumData?.title}
            </Typography>
            <Typography
              color="text.secondary"
              sx={{
                mb: 2,
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
              }}
            >
              {forumData?.description}
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center">
              <Chip
                label={`${forumData?.likes || 0} likes`}
                size="small"
                variant="outlined"
              />
              <Chip
                label={`${forumData?.comments || 0} comments`}
                size="small"
                variant="outlined"
              />
            </Stack>
          </CardContent>
        </Card>

        <Typography variant="subtitle2" fontWeight="600" sx={{ mb: 2 }}>
          Share on social media
        </Typography>

        {/* Social Media Share Buttons */}
        <Stack spacing={2}>
          <Button
            variant="outlined"
            startIcon={<Icons.Facebook />}
            onClick={handleFacebookShare}
            sx={{
              justifyContent: "flex-start",
              py: 1.5,
              borderColor: "#1877F2",
              color: "#1877F2",
              "&:hover": {
                borderColor: "#1877F2",
                bgcolor: "rgba(24, 119, 242, 0.04)",
              },
              "&:disabled": {
                opacity: 0.6,
              },
            }}
          >
            Share on Facebook
          </Button>

          <Button
            variant="outlined"
            startIcon={<Icons.TwitterX />}
            onClick={handleTwitterShare}
            sx={{
              justifyContent: "flex-start",
              py: 1.5,
              borderColor: "#0F1419",
              color: "#0F1419",
              "&:hover": {
                borderColor: "#0F1419",
                bgcolor: "rgba(15, 20, 25, 0.04)",
              },
            }}
          >
            Share on X
          </Button>
        </Stack>

        <Divider sx={{ my: 3 }} />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={onClose} variant="outlined" fullWidth>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShareDialog;
